<template>
  <a-card :bordered="false">
    <div class="p-b-40">
      <a-row align="middle">
        <a-col :span="6" :offset="1">
          <div class="s_text_r ">选择品牌商：</div>
        </a-col>
        <a-col :span="12">
          <div class="">
            <a-input
              readonly
              class="m-r-15"
              :style="{ width: '380px' }"
              v-model:value="brand_name"
              placeholder="请选择品牌商"
              @click="showBrand = true"
            />
            <CloseCircleOutlined
              class="CloseCircleOutlined s_shou"
              @click="clearVal"
            />
            <!-- <a-button class="" type="primary" @click="showBrand = true"
              >选择</a-button
            > -->
          </div>
        </a-col>
      </a-row>
      <a-row class="m-t-20" align="middle">
        <a-col :span="6" :offset="1">
          <p class="s_text_r ">标签：</p>
        </a-col>
        <a-col :span="12">
          <div class="s_flex_ali">
            <div class="">
              <a-input
                class="m-r-15"
                :style="{ width: '380px' }"
                v-model:value="code"
                placeholder="请输入标签"
              />
            </div>
            <a-button
              class="m-r-15"
              type="primary"
              v-has:codeInformationService="onSubmit"
              >查询</a-button
            >
            <a-button
              type="primary"
              v-has:codeInformationSetUnsold="setUnsoldOnSubmit"
              >设置未销售</a-button
            >
          </div>
        </a-col>
      </a-row>
    </div>

    <p
      class="p-b-10 s_text_c"
      style="height:200px;margin-top:100px"
      v-if="errorMsg"
    >
      {{ errorMsg }}
    </p>
    <a-descriptions bordered :column="2" class="m-t-20" v-if="showData">
      <a-descriptions-item label="流水号">{{
        codedata.code_sn || "-"
      }}</a-descriptions-item>
      <a-descriptions-item label="标签类型">{{
        codedata.current_code_type || "-"
      }}</a-descriptions-item>
      <a-descriptions-item label="批次号">{{
        codedata.batch_sn || "-"
      }}</a-descriptions-item>
      <a-descriptions-item label="品牌名称" :span="1">{{
        codedata.brand_name
      }}</a-descriptions-item>
      <a-descriptions-item label="批次备注">{{
        codedata.batch_remarks || "-"
      }}</a-descriptions-item>
      <a-descriptions-item label="防伪码">{{
        codedata.security_code || "-"
      }}</a-descriptions-item>
    </a-descriptions>
    <div class="m-t-20" v-if="codedata && codedata.scan_list">
      <a-table
        :pagination="false"
        bordered
        rowKey="id"
        :columns="tableCp.columns"
        :data-source="codedata.scan_list"
        class=""
        :scroll="{ x: 'max-content' }"
      >
        <template v-slot:is_sold="{ record }">
          <div>
            {{ record.is_sold ? "已销售" : "未销售" }}
          </div>
        </template>
      </a-table>
    </div>
  </a-card>
  <a-modal
    :keyboard="false"
    title="选择经品牌商"
    centered
    v-model:visible="showBrand"
    :width="1200"
    :footer="null"
    destroyOnClose
  >
    <selectBrand
      v-on:select="brandSelect"
      :checkout="false"
      :selectList="[{ id: brand_id }]"
    />
  </a-modal>
</template>
<script>
import { ref, reactive, toRefs, onMounted, inject } from "vue";
import { message } from "ant-design-vue";
import { $iscode } from "@/utils/app";

import { codeSearch, setCodeUnSold } from "@/api/codeManage";
import { DownOutlined, UpOutlined } from "@ant-design/icons-vue";
import store from "@/store";
export default {
  components: {},
  setup() {
    const state = reactive({
      brand_id: "",
      brand_name: "",
      brand_no: "",
      code: "",
      errorMsg: "", //码错误提示语
      codedata: {}, //码信息
      showData: false, //是否显示查询结果
      info: store.state.user.info,
      showBrand: false
    });

    const _lodash = inject("_lodash");
    const onSubmit = async () => {
      if (!state.code) {
        return message.error("请输入标签!");
      } else if (!state.brand_no) {
        return message.error("请选择品牌商!");
      } else {
        state.errorMsg = "";
        const hide = message.loading("正在加载中...", 0);
        let res = await codeSearch({
          code: state.code.replace(/\s*/g, ""),
          brand_id: state.brand_no
        })
          .then((res) => res.data)
          .catch((error) => error);
        if ($iscode(res)) {
          console.log(res);
          res.data.scan_list = res.data.scan_list || [];
          state.codedata = res.data;
          state.showData = true;
        } else {
          message.error(res.msg);
          state.showData = false;
          state.errorMsg = res.msg;
        }
        setTimeout(hide);
      }
    };
    const brandSelect = (e) => {
      state.brand_no = e.brand_no;
      state.brand_id = e.id;
      state.brand_name = e.brand_name;
      state.showBrand = false;
    };
    const route = inject("$route");

    // 设置为未销售
    const setUnsoldOnSubmit = async () => {
      if (!state.code) {
        return message.error("请输入标签!");
      } else if (!state.brand_no) {
        return message.error("请选择品牌商!");
      } else {
        state.errorMsg = "";
        const hide = message.loading("正在加载中...", 0);
        let res = await setCodeUnSold({
          code: state.code.replace(/\s*/g, ""),
          brand_id: state.brand_no
        })
          .then((res) => res.data)
          .catch((error) => error);
        if ($iscode(res)) {
          message.success(res.msg);
        } else {
          message.error(res.msg);
        }
        hide();
      }
    };
    // 表单配置
    const tableCp = reactive({
      columns: [
        {
          title: "扫码ID",
          dataIndex: "scan_id",
          key: "scan_id"
        },
        {
          title: "扫码次数",
          dataIndex: "scan_num",
          key: "scan_num"
        },
        {
          title: "是否已售",
          dataIndex: "is_sold",
          key: "is_sold",
          slots: { customRender: "is_sold" }
        },
        {
          title: "扫码时间",
          dataIndex: "created_time",
          key: "created_time"
        }
      ]
    });
    onMounted(() => {});
    return {
      ...toRefs(state),
      onSubmit,
      brandSelect,
      setUnsoldOnSubmit,
      tableCp
    };
  }
};
</script>
<style lang="less" scoped>
.s_ptb16lr24 {
  padding: 14px 24px;
}

.list_bl {
  border-left: 1px solid #f0f0f0;
}

.list_bb {
  border-bottom: 1px solid #f0f0f0;
}

.list_bt {
  border-top: 1px solid #f0f0f0;
}

.red {
  color: #f04635;
}

.tree_box p:last-child {
  border-bottom: 0;
}

.ms_box .ms_box_item:last-child {
  border-bottom: 0;
}
/deep/.richContent img {
  width: 100%;
}
</style>
